import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import { LANGUAGE_RESOURCES } from './resources'

i18n
  .use(initReactI18next)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: LANGUAGE_RESOURCES,
    nsSeparator: false,
    interpolation: { escapeValue: false }, // React handles XSS
  })

export default i18n
